import { numeroDoEventoOuNulo } from '@/shared/utils/numeroDoEvento';

import type { PainelAndamento, PainelAndamentoAnexo } from '../types';

function objeto(valor: unknown): valor is Record<string, unknown> {
  return typeof valor === 'object' && valor !== null;
}

function anexoValido(valor: unknown): valor is PainelAndamentoAnexo {
  return (
    objeto(valor) &&
    typeof valor.id === 'string' &&
    typeof valor.nome === 'string' &&
    typeof valor.tamanhoBytes === 'number' &&
    Number.isFinite(valor.tamanhoBytes)
  );
}

function andamentoValido(valor: unknown): valor is PainelAndamento {
  if (!objeto(valor) || !objeto(valor.autor)) return false;
  return (
    typeof valor.id === 'string' &&
    valor.id !== '' &&
    (valor.numero === null || (typeof valor.numero === 'string' && /^\d+$/.test(valor.numero))) &&
    typeof valor.tipo === 'string' &&
    typeof valor.descricao === 'string' &&
    (valor.descricaoHtml === null || typeof valor.descricaoHtml === 'string') &&
    typeof valor.dataHora === 'string' &&
    valor.dataHora !== '' &&
    typeof valor.autor.nome === 'string' &&
    (valor.autor.id === null || typeof valor.autor.id === 'string') &&
    (valor.autor.papel === null || typeof valor.autor.papel === 'string') &&
    Array.isArray(valor.anexos) &&
    valor.anexos.every(anexoValido)
  );
}

export function parseAndamentoExato(valor: unknown): PainelAndamento {
  if (!objeto(valor)) throw new Error('Evento indisponível para este acesso');
  const numero = numeroDoEventoOuNulo(valor.numero);
  if (numero === null && valor.numero !== null) {
    throw new Error('Evento indisponível para este acesso');
  }
  // Backend anterior à formatação não manda o campo: o andamento é de texto simples.
  const andamento = { ...valor, numero, descricaoHtml: valor.descricaoHtml ?? null };
  if (!andamentoValido(andamento)) throw new Error('Evento indisponível para este acesso');
  return andamento;
}
